import { DeliveryType } from '@libs/core';

export type Quantity = {
    label: string;
    value: string;
};

const MAX_DISPLAY_QTY = 500;

/**
 * [SB-1730] Temporary overrides to max display quantity for certain SKU's
 *
 * This was needed because at the time there was no way to limit the
 * maximum order quantity.
 *
 * This will be removed in the near future.
 */
const MAX_DISPLAY_QTY_OVERRIDE = 10;
const MAX_DISPLAY_QTY_OVERRIDE_SKUS = [
    5296631, 5353547, 5296633, 5282570, 5282569, 5296630, 5262323, 5262322,
    5282041, 5300985, 5296632, 5300977, 5296629, 5300986, 5107910, 5194822,
    5269945, 5100352, 5311323, 5296190, 5331755, 5350511, 5349538, 5266865,
    5354649, 5034868, 1811626, 5300983, 5319248, 5324384,
];
const overrideMaxDisplayQuantityBySku = (sku?: number) =>
    sku && MAX_DISPLAY_QTY_OVERRIDE_SKUS.includes(sku)
        ? MAX_DISPLAY_QTY_OVERRIDE
        : MAX_DISPLAY_QTY;

const getAvailableQuantities = (
    minQty = 1,
    stock = 0,
    maxDisplayQty = MAX_DISPLAY_QTY
) => {
    const availableQuantities: Quantity[] = [];

    if (stock === 0 || minQty > stock) {
        return availableQuantities;
    }

    const qty = minQty < 1 ? 1 : minQty;

    for (let i = qty; i <= stock && i <= maxDisplayQty; i += qty) {
        availableQuantities.push({
            label: i.toString(),
            value: i.toString(),
        });
    }

    return availableQuantities;
};

const getDefaultSelectedInventory = (
    bopisDisabled: boolean,
    sddDisabled: boolean,
    isAutoshipSupported: boolean,
    isShipToHomeSupported: boolean
) => {
    if (bopisDisabled && isShipToHomeSupported) {
        return DeliveryType.STM;
    }
    if (bopisDisabled && !isShipToHomeSupported && isAutoshipSupported) {
        return DeliveryType.AUTOSHIP;
    }
    if (
        bopisDisabled &&
        !isShipToHomeSupported &&
        !isAutoshipSupported &&
        !sddDisabled
    ) {
        return DeliveryType.SDD;
    }

    return DeliveryType.BOPIS;
};

export {
    overrideMaxDisplayQuantityBySku,
    getAvailableQuantities,
    getDefaultSelectedInventory,
};
